<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import { computed } from 'vue';
import * as propDefs from './prop-definitions';
import tagging from '../../lib/tagging/mixin';
import { VideoModes } from '../../config/video-modes';

const {
  video: videoProps,
  playlist: playlistProps,
  common: commonProps,
  tagging: taggingProps,
} = propDefs;

export default {
  name: 'refapp-video-provider',
  mixins: [tagging],
  provide() {
    return Object.keys({
      ...propDefs[this.mode || VideoModes.VIDEO],
      ...commonProps,
      ...taggingProps,
    }).reduce((acc, curr) => {
      acc[curr] = computed(() => this[curr]);
      return acc;
    }, {});
  },
  props: {
    ...videoProps,
    ...playlistProps,
    ...commonProps,
    ...taggingProps,
  },
  render() {
    const isVue3Slot = this.$slots.default instanceof Function;

    if (isVue3Slot) {
      return this.$slots.default();
    }

    return this.$slots.default;
  },
};
</script>
